/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_BlurbInputs */

const en_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For three decades, magazines have ranked Mark Egly the premier golf instructor in Iowa. Pro, amateur, or beginner. Mark is the teacher to see.`)
};

const es_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante tres décadas, las revistas han clasificado a Mark Egly como el instructor de golf más destacado de Iowa. Profesional, aficionado o principiante. Mark es el maestro que buscas.`)
};

const de_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit drei Jahrzehnten küren Zeitschriften Mark Egly zum besten Golflehrer in Iowa. Profi, Amateur oder Anfänger: Mark ist die erste Adresse.`)
};

const zh_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三十年来，各大杂志一直将 Mark Egly 评为爱荷华州首屈一指的高尔夫教练。无论是职业球员、业余爱好者还是初学者，Mark 都是你的首选教练。`)
};

const ar_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`على مدى ثلاثة عقود، صنّفت المجلات Mark Egly أفضل مدرب غولف في Iowa. محترف أو هاوٍ أو مبتدئ. Mark هو المدرب الذي تبحث عنه.`)
};

const fr_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis trois décennies, les magazines classent Mark Egly comme le meilleur instructeur de golf de l'Iowa. Pro, amateur ou débutant : Mark est le coach qu'il vous faut.`)
};

const vi_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trong ba thập kỷ, các tạp chí đã xếp Mark Egly là huấn luyện viên golf hàng đầu tại Iowa. Chuyên nghiệp, nghiệp dư, hay người mới bắt đầu. Mark là người thầy bạn nên tìm đến.`)
};

const sw_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa miongo mitatu, majarida yamemtaja Mark Egly kuwa mkufunzi bora wa gofu huko Iowa. Mchezaji wa kulipwa, wa ridhaa au anayeanza: Mark ndiye kocha wa kumwendea.`)
};

const th_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตลอดสามทศวรรษ นิตยสารต่างๆ จัดอันดับให้ Mark Egly เป็นผู้ฝึกสอนกอล์ฟชั้นนำของรัฐไอโอวา ไม่ว่าจะเป็นมือโปร มือสมัครเล่น หรือมือใหม่ Mark คือโค้ชที่คุณควรมาหา`)
};

const bs_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Već tri decenije časopisi rangiraju Marka Eglyja kao vodećeg instruktora golfa u Iowi. Bilo da ste profesionalac, amater ili početnik, Mark je trener kojem se treba obratiti.`)
};

const ja_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30年にわたり、雑誌はMark Eglyをアイオワ州最高のゴルフインストラクターに選んできました。プロ、アマチュア、初心者を問わず。Markは頼れるコーチです。`)
};

const ko_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30년 동안 여러 잡지가 Mark Egly를 Iowa 최고의 골프 강사로 선정했습니다. 프로, 아마추어, 초보자 누구든 Mark가 찾아가야 할 코치입니다.`)
};

const pt_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há três décadas, as revistas apontam Mark Egly como o melhor instrutor de golfe de Iowa. Profissional, amador ou iniciante: Mark é o treinador certo para você.`)
};

const it_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da tre decenni le riviste indicano Mark Egly come il miglior istruttore di golf dell'Iowa. Professionista, amatore o principiante: Mark è l'istruttore a cui rivolgersi.`)
};

const sv_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tre decennier har tidningar rankat Mark Egly som den främsta golfinstruktören i Iowa. Proffs, amatör eller nybörjare: Mark är tränaren du ska gå till.`)
};

const nl_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al drie decennia noemen tijdschriften Mark Egly de beste golfinstructeur van Iowa. Prof, amateur of beginner: Mark is de coach bij wie je moet zijn.`)
};

const da_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tre årtier har magasiner kåret Mark Egly som den førende golfinstruktør i Iowa. Pro, amatør eller nybegynder: Mark er træneren, du skal gå til.`)
};

const nb_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tre tiår har magasiner rangert Mark Egly som den fremste golfinstruktøren i Iowa. Proff, amatør eller nybegynner: Mark er treneren du bør gå til.`)
};

const fi_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jo kolmen vuosikymmenen ajan lehdet ovat rankanneet Mark Eglyn Iowan parhaaksi golfopettajaksi. Ammattilainen, amatööri tai aloittelija: Mark on valmentaja, jonka puoleen kannattaa kääntyä.`)
};

const pl_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od trzech dekad czasopisma uznają Marka Egly’ego za najlepszego instruktora golfa w Iowa. Zawodowiec, amator czy początkujący: Mark to trener, do którego warto się zgłosić.`)
};

const ru_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже три десятилетия журналы называют тренера Mark Egly лучшим инструктором по гольфу в Iowa. Профессионал, любитель или новичок: Mark — тренер, к которому стоит прийти.`)
};

const tr_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üç on yıldır dergiler Mark Egly’yi Iowa’daki önde gelen golf eğitmeni olarak gösteriyor. Profesyonel, amatör veya yeni başlayan: Mark, başvurmanız gereken eğitmen.`)
};

const hi_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तीन दशकों से पत्रिकाएँ Mark Egly को Iowa का सर्वश्रेष्ठ गोल्फ प्रशिक्षक मानती आई हैं। प्रो, शौकिया या शुरुआती: Mark ही वह कोच हैं जिनके पास जाना चाहिए।`)
};

const id_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selama tiga dekade, berbagai majalah menobatkan Mark Egly sebagai instruktur golf terbaik di Iowa. Profesional, amatir, atau pemula: Mark adalah pelatih yang tepat untuk Anda.`)
};

const ms_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selama tiga dekad, majalah-majalah menobatkan Mark Egly sebagai jurulatih golf terbaik di Iowa. Profesional, amatur atau pemula: Mark ialah jurulatih yang patut anda temui.`)
};

const cs_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Už tři desetiletí časopisy označují Marka Eglyho za nejlepšího golfového instruktora v Iowě. Profík, amatér, nebo začátečník: Mark je trenér, za kterým se vyplatí jít.`)
};

const el_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εδώ και τρεις δεκαετίες, τα περιοδικά κατατάσσουν τον Mark Egly ως τον κορυφαίο εκπαιδευτή γκολφ στην Iowa. Επαγγελματίας, ερασιτέχνης ή αρχάριος: ο Mark είναι ο προπονητής στον οποίο αξίζει να απευθυνθείς.`)
};

const he_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כבר שלושה עשורים מגזינים מדרגים את Mark Egly כמדריך הגולף המוביל ב-Iowa. מקצוענים, חובבנים או מתחילים: Mark הוא המאמן שאליו כדאי לפנות.`)
};

const af_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al drie dekades lank noem tydskrifte Mark Egly die voorste gholfinstrukteur in Iowa. Pro, amateur of beginner: Mark is die afrigter na wie jy toe moet gaan.`)
};

const hu_footer_blurb = /** @type {(inputs: Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Három évtizede a magazinok Mark Eglyt tartják Iowa legjobb golfoktatójának. Profi, amatőr vagy kezdő: Mark az az edző, akihez érdemes fordulni.`)
};

/**
* | output |
* | --- |
* | "For three decades, magazines have ranked Mark Egly the premier golf instructor in Iowa. Pro, amateur, or beginner. Mark is the teacher to see." |
*
* @param {Footer_BlurbInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_blurb = /** @type {((inputs?: Footer_BlurbInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_BlurbInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_blurb(inputs)
	if (locale === "de") return de_footer_blurb(inputs)
	if (locale === "zh") return zh_footer_blurb(inputs)
	if (locale === "ar") return ar_footer_blurb(inputs)
	if (locale === "fr") return fr_footer_blurb(inputs)
	if (locale === "vi") return vi_footer_blurb(inputs)
	if (locale === "sw") return sw_footer_blurb(inputs)
	if (locale === "th") return th_footer_blurb(inputs)
	if (locale === "bs") return bs_footer_blurb(inputs)
	if (locale === "ja") return ja_footer_blurb(inputs)
	if (locale === "ko") return ko_footer_blurb(inputs)
	if (locale === "pt") return pt_footer_blurb(inputs)
	if (locale === "it") return it_footer_blurb(inputs)
	if (locale === "sv") return sv_footer_blurb(inputs)
	if (locale === "nl") return nl_footer_blurb(inputs)
	if (locale === "da") return da_footer_blurb(inputs)
	if (locale === "nb") return nb_footer_blurb(inputs)
	if (locale === "fi") return fi_footer_blurb(inputs)
	if (locale === "pl") return pl_footer_blurb(inputs)
	if (locale === "ru") return ru_footer_blurb(inputs)
	if (locale === "tr") return tr_footer_blurb(inputs)
	if (locale === "hi") return hi_footer_blurb(inputs)
	if (locale === "id") return id_footer_blurb(inputs)
	if (locale === "ms") return ms_footer_blurb(inputs)
	if (locale === "cs") return cs_footer_blurb(inputs)
	if (locale === "el") return el_footer_blurb(inputs)
	if (locale === "he") return he_footer_blurb(inputs)
	if (locale === "af") return af_footer_blurb(inputs)
	if (locale === "hu") return hu_footer_blurb(inputs)
	return en_footer_blurb(inputs)
});